import axios from "axios";
import { errorHandler } from "@/services/errorHandler";
import store from "@/store";

export default {
    state: {
        userData: JSON.parse(localStorage.getItem('userData')) || null,
        apiKey: sessionStorage.getItem('Api-Key') || null,
    },

    getters: {
        isAuthenticated: (state) => !!state.apiKey,
        getuserData: (state) => state.userData,
        getApi: (state) => state.apiKey,
    },

    mutations: {
        setAuth(state, { userData, apiKey }) {
            state.userData = userData;
            state.apiKey = apiKey;
            sessionStorage.setItem('Api-Key', apiKey);
            localStorage.setItem('userData', JSON.stringify(userData));
        },
        clearAuth(state) {
            state.userData = null;
            state.apiKey = null;
            state.url = null;
            sessionStorage.removeItem('Api-Key');
            localStorage.removeItem('userData');
            localStorage.removeItem('url');
        },
        reset(state) {
            state.url = null;
            localStorage.removeItem('url');
        },
    },

    actions: {
        appLogin: (context, payload) => {
            return axios.post(gateway + 'login', payload)
                .then(async ({data}) => {
                    const apiKey = data['Api-Key'];
                    const userData = {
                        customerName: data.customerName,
                        logo: data.logo
                    };
                    await store.commit('setAuth', { userData, apiKey });
                }).catch((err) => errorHandler.tomcatError(err));
        },

        logout(context) {
            context.commit('clearAuth');
            return {
                success: true
            };
        },
    }
};
